import { CcLibrarySet } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setCcLibrarySetBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_BASE_ROUTE),
    baseRoute,
})
export const setCcLibrarySetList = (setList: types.CcLibrarySetList) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_LIST),
    setList,
})
export const setCcLibrarySetIds = (setIds: readonly number[]) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_IDS),
    setIds,
})
export const setCcLibrarySetView = (set: CcLibrarySet) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_VIEW),
    set,
})
export const setCcLibrarySetEdit = (set: CcLibrarySet) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_EDIT),
    set,
})
export const setCcLibrarySetSort = (sortColumn: keyof CcLibrarySet, sortOrder: OrderType) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_SORT),
    sortColumn,
    sortOrder,
})
export const setCcLibrarySetFilters = (filters: types.CcLibrarySetFilters) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_FILTERS),
    filters,
})
export const setCcLibrarySetReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_RELOAD_LIST),
    value,
})
export const setCcLibrarySetReloadView = (value: boolean) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_RELOAD_VIEW),
    value,
})
export const setCcLibrarySetReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_RELOAD_EDIT),
    value,
})


// import from library
export const setCcLibrarySetImportFromLibraryList = (setList: types.CcLibrarySetList) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_LIST),
    setList,
})
export const setCcLibrarySetImportFromLibraryIds = (setIds: readonly number[]) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_IDS),
    setIds,
})
export const setCcLibrarySetImportFromLibrarySort = (sortColumn: keyof CcLibrarySet, sortOrder: OrderType) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_SORT),
    sortColumn,
    sortOrder,
})
export const setCcLibrarySetImportFromLibraryFilters = (filters: types.CcLibrarySetImportFilters) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_FILTERS),
    filters,
})


// import from account
export const setCcLibrarySetImportFromAccountList = (setList: types.CcLibrarySetList) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_LIST),
    setList,
})
export const setCcLibrarySetImportFromAccountIds = (setIds: readonly number[]) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_IDS),
    setIds,
})
export const setCcLibrarySetImportFromAccountSort = (sortColumn: keyof CcLibrarySet, sortOrder: OrderType) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_SORT),
    sortColumn,
    sortOrder,
})
export const setCcLibrarySetImportFromAccountFilters = (filters: types.CcLibrarySetImportFilters) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_FILTERS),
    filters,
})


export const setCcLibrarySetImportId = (setId: number) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_IMPORT_ID),
    setId,
})
export const setCcLibrarySetReloadImported = (value: boolean) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_RELOAD_IMPORTED),
    value,
})
